<!--
  * props
    - item : 저장될 사이트 버전 오브젝트
  * event
    - apply : 적용 버튼 클릭
-->
<template>
  <div>
    <b-card key="DETAIL"
            header-tag="header">
      <!-- 헤더 -->
      <div slot="header">
        <i class="fa fa-bars"></i> <strong>데이터 파일 구조 복사</strong>
        <div class="card-actions">
          <a href="#" v-ripple @click="handleCancelClicked">
            <i class="fa fa-close"></i>
          </a>
        </div>
      </div>
      <div>
        <!-- row1 -->
        <b-row class="mb-2">
          <b-col>
            ▶︎ 복사할 사이트 버전을 선택 하시면, 선택한 사이트 버전의 데이터 파일 구조와 동일한 데이터 파일 구조가 자동으로 생성됩니다.
          </b-col>
        </b-row>
        <!-- row2 -->
        <b-row class="mb-2">
          <b-col>
            <b-form-select v-model="item.copyBy"
                           :options="siteVersionOptions">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="float-right">
          <b-col cols="12">
            <b-button v-ripple variant="primary" @click="handleApplyClicked">적용</b-button>
            <b-button v-ripple variant="secondary" @click="handleCancelClicked">취소</b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      siteVersionOptions: []
    }
  },
  mounted () {
    this.$http.get('/setting/sites/versions')
      .then((response) => {
        let sites = response.data.result.sites
        let options = [{
          value: '-',
          text: ' - 복사 안함 - ',
          siteId: '',
          siteVersion: ''
        }]
        for (let i = 0; i < sites.length; i++) {
          sites[i].siteValue = sites[i].siteId + '-' + sites[i].siteVersion
          options.push({
            value: sites[i].siteValue,
            text: (sites[i].siteName + ' (' + sites[i].siteVersion + ')'),
            siteId: sites[i].siteId,
            siteVersion: sites[i].siteVersion
          })
        }
        this.$data.siteVersionOptions = options
      })
      .catch((error) => {
        this.$toasted.global.error(this.formatErrorMessage(error))
      })
  },
  methods: {
    // 적용 버튼 클릭 시
    handleApplyClicked () {
      // 화면이 닫히기 전 초기화 처리
      this.$data.siteVersionOptions = []
      // 상위 컴포넌트로 이벤트 발생
      this.$emit('apply', this.$props.item)
    },
    // 취소 버튼 클릭 시
    handleCancelClicked () {
      // 화면이 닫히기 전 초기화 처리
      this.$data.siteVersionOptions = []
      // 상위 컴포넌트로 이벤트 발생
      this.$emit('cancel', this.$props.item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CopiedSiteVersion.vue